import { FlatDescription } from './FlatDescription';

export type { TypeFlatDescriptionProps } from './types';
export default FlatDescription;
